module.exports = __webpack_public_path__ + "static/media/game-background-convetions.2fcb6d6c.jpg";